

















































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { AcgnPop } from '@acgn/herm/src/ui';
import { Popover } from 'element-ui';
import { namespace } from 'vuex-class';
import { AcgnAddGroup, AcgnAddTask, AcgnEditTask, AcgnSortGroup, AcgnSortTask } from './components/index';
import event from '@acgn/herm/src/util/event';
import { setDateTimeStamp, getDateTimeStamp } from '@acgn/herm/src/util/time';

const TaskGroupAction = namespace('desk/taskGroup').Action;
const TaskGroupGetter = namespace('desk/taskGroup').Getter;
const CommGetter = namespace('desk/comm').Getter;

@Component({
  components: {
    AcgnPop,
    AcgnAddGroup,
    AcgnAddTask,
    AcgnSortGroup,
    AcgnSortTask,
    AcgnEditTask,
    [Popover.name]: Popover
  }
})

/**
 * 项目管理，画手工作台左侧菜单
 */
export default class AcgnTaskMenu extends Vue {
  @Prop({ default: [] }) public manageGroupList: any; // 类型列表
  @Prop({ default: 'comic' }) public source: any; // 类型列表
  @Prop() public getProjectList: any; // 获取列表
  @Prop({ default: false }) public hasTask: any; // 是否含有任务
  @Prop({ default: '1003' }) public authorityCode: any; // 权限码
  @TaskGroupAction private getTaskGroupStatus: any; // 获取任务组
  @TaskGroupAction private getTaskStatus: any; // 获取任务组
  @TaskGroupAction private setStatusTaskGroup: any; // 删除任务组
  @TaskGroupAction private setStatusTask: any; // 删除任务
  @TaskGroupGetter private taskGroupStatusList: any; // 任务组loading
  @TaskGroupGetter private loadings: any; // 任务组loading
  @CommGetter private attributeData: any; // 公共类型

  private visible: any = false;
  private visibleEdit: any = false;
  private eidtGroupName: any = false; // 编辑任务组名称
  private groupId: any = ''; // 编辑任务id
  private visibleGroup: any = false;
  private isReverse: any = false;
  private visibleSortGroup: any = false;
  private visibleSortTask: any = false;
  private searchGroup: any = '';
  private taskItem: any = 0;
  private comicId: any = 0;
  private taskIndexNav: any = 0;
  private taskUrl: any = '';
  private taskList: any = [];
  private editTaskItem: any = {};
  private taskGroupList: any = [];
  private taskGroupListAll: any = [];

  private pickerOptions: any = {
    disabledDate(time: any) {
      return time.getTime() + 86400000 <= Date.now(); // 选当前时间之后的时间
    }
  };

  // 获取表单验证规则
  private get rules() {
    const rules = {
      group_name: [
        { required: true, message: '请输入任务组名称', trigger: 'blur' }
      ],
      dead_line: [
        { required: true, message: '请输入截止时间', trigger: 'blur' }
      ],
    };
    return rules;
  }
  private get rulesTask() {
    const rules = {
      task_name: [
        { required: true, message: '请输入任务组名称', trigger: 'blur' }
      ],
    };
    return rules;
  }

  // 审批状态样式
  private getClassSta(status: any) {
    switch (status) {
      case 0:
        return 'color--success';
      case 1:
        return 'color--gray';
      case 2:
        return 'color--danger';
    }
  }

  // 审批状态列表
  private get statusName() {
    return this.attributeData.other_type[3];
  }

  // 审批状态名称
  private getNameSta(status: any) {
    return this.statusName[status].name;
  }

  // 任务组排序
  private getsortGroup(item: any) {
    this.groupId = item.id;
    this.eidtGroupName = item.group_name;
    this.visibleSortGroup = true;
  }

  // 任务排序
  private getsortTask(item: any) {
    this.editTaskItem = item;
    this.visibleSortTask = true;
  }

  // 编辑任务组
  private editTaskGroup(groupName: any, id: any) {
    this.showTaskModel(groupName);
    this.groupId = id;
  }

  // 编辑任务
  private editTask(item: any) {
    this.editTaskItem = item;
    this.visibleEdit = true;
  }

  // 删除任务组
  private delTaskGroup(item: any) {
    this.$confirm(`确认将“${item.group_name}”移至回收站？`, '提示').then(async () => {
      const params = {
        recycle_status: 1,
        group_id: item.id
      };
      await this.setStatusTaskGroup(params);
      this.$message.success('删除任务组成功');
      this.groupList();
      if (item.id === this.taskItem.id) {
        if (this.groupStatusList.length === 0) {
          this.gotoTask(item.id, 0);
        }
        this.getTask(this.groupStatusList[0]);
      }
    }).catch((ex) => { });
  }

  // 删除任务
  private delTask(item: any) {
    this.$confirm(`确认将“${item.task_name}”移至回收站？`, '提示').then(async () => {
      const params = {
        recycle_status: 1,
        task_id: item.id
      };
      await this.setStatusTask(params);
      this.refreshTaskList();
      if (item.id === this.taskIndexNav) {
        if (this.getTasklist.length === 0) {
          this.gotoTask(this.taskItem.id, item.id);
        }
        this.gotoTask(this.taskItem.id, 0);
      }
      this.$message.success('删除任务成功');
    }).catch((ex) => { });
  }

  // 刷新任务列表
  private async refreshTaskList() {
    const {result} = await this.getTaskStatus({task_group_id: this.taskItem.id});
    this.taskList = result;
  }

  // 添加任务
  private addTask() {
    this.visible = true;
  }

  // 添加任务组
  private showTaskModel(name: any) {
    this.eidtGroupName = name;
    this.visibleGroup = true;
  }

  private get groupStatusList() {
    if (!this.taskGroupStatusList.result) {
      return [];
    }
    let result = [ ...this.taskGroupStatusList.result ];
    if (this.isReverse) {
      if (this.searchGroup) {
        result = result.filter((item: any) => item.group_name.includes(this.searchGroup));
      }
      return result.reverse();
    }
    if (!this.searchGroup) {
      return result;
    }
    return result.filter((item: any) => item.group_name.includes(this.searchGroup));
  }

  // 排序时强制正序
  private setSort() {
    this.isReverse = false;
  }

  // 获取任务组列表
  private async groupList() {
    await this.getTaskGroupStatus({ project_id: this.comicId });
  }

  private get getTasklist() {
    return this.taskList;
  }

  private isOtherpage() {
    const { task_group_id, task_id } = this.$route.params;
    // 判断是否其他页面传入
    if (task_group_id) {
      this.groupStatusList.map((i: any, index: any) => {
        if (parseInt(task_group_id, 0) === i.id) {
          (this.$refs as any).menuScroll.scrollTop = 40 * index;
          this.taskItem = i;
          this.refreshTask(i);
          this.taskList.map((j: any, k: any) => {
            if (parseInt(task_id, 0) === j.id) {
              this.getTaskDetail(k, j);
            }
          });
        }
      });
      return true;
    }
    return false;
  }

  // 任务组列表是否选中
  private async selectGroup() {
    this.taskUrl = this.source;
    if (this.isOtherpage()) {
      return false;
    }
  }

  // 刷新任务列表
  private async refreshTask(item: any) {
    this.taskList = [ ...item.tasks ];
  }

  private async created() {
    const { id } = this.$route.params;
    this.comicId = id;
    await this.groupList();
    this.selectGroup();
    event.on('$refreshTaskList', async () => {
      await this.groupList();
      await this.refreshTaskList();
      this.isOtherpage();
    });
  }

  private beforeDestroy() {
    event.off('$refreshTaskList');
  }
  // 项目管理点击
  private selectCliGroup(item: any) {
    this.$router.push({ name: item.url });
  }

  // 前往任务跳转路由
  private gotoTask(groupId: any, taskId: any) {
    const params = { id: this.comicId, task_group_id: groupId, task_id: taskId };
    if (this.taskUrl === 'worker') {
      this.$router.push({
        name: 'desk-workerTask',
        params
      });
      return false;
    }
    this.$router.push({
      name: 'desk-comicAuthTask',
      params
    });
  }

  // 前往任务组
  private async getTask(item: any) {
    this.taskItem = item;
    if (item.tasks.length > 0) {
      this.refreshTask(item);
      this.gotoTask(item.id, item.tasks[0].id);
    } else {
      this.gotoTask(item.id, 0);
    }
  }

  // 前往子任务
  private getTaskDetail(index: any, item: any) {
    this.taskIndexNav = item.id;
    const data: any = {
      id: item.id,
      groupName: this.taskItem.group_name,
      taskName: item.task_name,
      dead_line: this.taskItem.dead_line,
      groupId: this.taskItem.id,
      projectId: this.taskItem.project_id
    };
    this.getProjectList(data);
    this.gotoTask(this.taskItem.id, item.id);
  }

  // 排序任务组
  private sortTaskGroup() {
    this.isReverse = !this.isReverse;
    // this.taskGroupList = this.taskGroupList.reverse();
    // this.taskGroupListAll = this.taskGroupListAll.reverse();
  }

  // 排序任务
  private sortTask() {
    this.taskList = this.taskList.reverse();
  }
}
